<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>船舶名称：</p>
        <el-input v-model="shipIpt" size="mini" style="width:150px" placeholder="请输入船舶名称"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>航次：</p>
        <el-input v-model="voyageIpt" size="mini" style="width:150px" placeholder="请输入航次"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>任务编号：</p>
        <el-input v-model="numberIpt" size="mini" style="width:150px" placeholder="请输入任务编号"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>停靠原因：</p>
        <el-select v-model="reasonIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.id" :label="item.attrNm" :value="item.id"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 400px">
        <p>停靠时间：</p>
        <el-date-picker v-model="startTime" size="mini" style="width:150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="开始日期"/>
        <span style="display:inline-block;width:15px;text-align:center;font-size:18px">-</span>
        <el-date-picker v-model="endTime" size="mini" style="width:150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="结束日期"/>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          :row-class-name="tableRowClassName"
        >
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="shipName" label="船舶名称" align="center"/>
          <el-table-column prop="voyageNumber" label="航次" align="center"/>
          <el-table-column prop="taskNumber" label="任务编号" align="center"/>
          <el-table-column prop="stopReason" label="停靠原因" align="center"/>
          <el-table-column prop="stopPortName" label="停靠港口" align="center"/>
          <el-table-column prop="stopStartTime" label="停靠开始时间" align="center"/>
          <el-table-column prop="stopEndTime" label="停靠结束时间" align="center"/>
          <el-table-column label="操作" width="140" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情用户信息" :visible.sync="detailDialogVisible" width='650px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">船舶名称：</span>
              <span>{{detailData.shipName}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">航次：</span>
                <span>{{detailData.voyageNumber}}</span>
              </div>
              <div>
                <span class="span1">任务编号：</span>
                <span>{{detailData.taskNumber}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">出港港口：</span>
                <span>{{detailData.leavePortName}}</span>
              </div>
              <div>
                <span class="span1">到港港口：</span>
                <span>{{detailData.arrivalPortName}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">停靠原因：</span>
              <span>{{detailData.stopReason}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">停靠港口：</span>
              <span>{{detailData.stopPortName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">详细地址：</span>
              <span>{{detailData.stopPortAddress}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">停船开始时间：</span>
                <span>{{detailData.stopStartTime}}</span>
              </div>
              <div>
                <span class="span1">停船结束时间：</span>
                <span>{{detailData.stopEndTime}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">备注：</span>
              <span>{{detailData.remark}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">照片：</span>
              <div class="imgContainer">
                <el-image
                  v-for="(item,index) in detailData.img"
                  :key="index"
                  style="width: 100px; height: 100px;margin-right:10px; "
                  :src="baseImgUrl + item"
                  :preview-src-list="[baseImgUrl + item]"
                  fit="cover"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column prop="createTime" label="操作时间" align="center" width="160px"/>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='550px' center @close="dialogClose" :close-on-click-modal="false" top="10vh">
      <div class="company">
        <el-form :model="teamData" label-width="130px" :rules="rules" ref="ruleForm">
          <el-form-item label="选择船舶：" prop="ship" style="margin-bottom: 0">
            <el-select v-model="teamData.ship" size="mini" filterable style="width:90%" placeholder="请选择船舶" @change="shipChange" value-key="id">
              <el-option v-for="item in shipOption" :key="item.id" :label="item.name" :value="item"/>
            </el-select>
            <hr color="#F0F0F2"/>
          </el-form-item>
          <div class="companyShip">
            <div style="width:100%;display: flex;align-items:center">
              <span style="width:35%;">航次：{{teamData.voyage?teamData.voyage:'-'}}</span>
              <span>任务编号：{{teamData.number?teamData.number:'-'}}</span>
            </div>
            <span>出港码头：{{teamData.port2?teamData.port2:'-'}}</span>
          </div>
          <el-form-item label="停靠原因：" prop="reason">
            <el-select v-model="teamData.reason" filterable size="mini" style="width:90%" placeholder="请选择停靠原因" value-key="id">
              <el-option v-for="item in reasonOption" :key="item.id" :label="item.attrNm" :value="item"/>
            </el-select>
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="停靠码头：" prop="port">
            <el-select v-model="teamData.port" filterable size="mini" style="width:90%" placeholder="请选择停靠码头" value-key="id">
              <el-option v-for="item in portOption" :key="item.id" :label="item.name" :value="item"/>
            </el-select>
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="停靠开始时间：" prop="start">
            <el-date-picker
              v-model="teamData.start"
              :style="'width:100%'"
              size="mini"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择停靠开始时间"/>
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="停靠结束时间：" prop="end" style="margin-bottom: 20px">
            <el-date-picker
              v-model="teamData.end"
              :style="'width:100%'"
              size="mini"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择停靠结束时间"/>
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="备注：" prop="mark">
            <el-input
              type="textarea"
              :style="'width:90%'"
              v-model="teamData.mark"
              placeholder="请输入备注"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2" style="bottom:-10px;"/>
          </el-form-item>
          <el-form-item label="上传照片：" prop="img" style="margin-bottom:0">
            <div class="imgUp">
              <div class="imgLength"><span>{{teamData.img.length}}/5</span></div>
              <el-upload
                ref="uploads"
                list-type="picture-card"
                :action="uploadUrl"
                :data="uploadData"
                accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                :before-upload="beforeAvatarUpload"
                :on-change="uploadChange"
                :on-remove="handleRemove"
                :on-progress="progress"
                :on-success="success"
                :file-list="teamData.img"
                :limit="5"
              >
                <div class="img-box">
                  <i class="el-icon-plus"/>
                  <span class="tips">点击上传照片</span>
                </div>
              </el-upload>
            </div>
            <hr color="#F0F0F2" style="bottom:-10px;"/>
          </el-form-item>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="imgIsUpload" @click="addClick">添加</el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPorts,
  getShips,
  getStopByDeployId,
  stopShipCvAdd,
  stopShipCvDetail,
  stopShipCvPageList, stopShipCvUpdate
} from "@/service/vehiclelog";
import {getParam} from "@/service/getData";
import {baseImgUrl, baseUrl} from "@/config/env";

export default {
  components: {
  },
  data() {
    return {
      shipIpt:'',
      voyageIpt:'',
      numberIpt:'',
      // timeIpt:'',
      startTime: '',
      endTime: '',
      reasonIpt:'',
      stateOption:[],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[],
      detailDialogVisible:false,
      detailData:{
        img:[],
      },
      operationData:[],
      dialogTitle:'',
      dialogVisible:false,
      shipOption:[
        {value:'船舶1',label:'船舶1'},
        {value:'船舶2',label:'船舶2'},
        {value:'船舶3',label:'船舶3'},
      ],
      reasonOption:[],
      portOption:[],
      teamData:{
        teamName:'',
        keyword:'',
        account:'',
        area:'',
        address:'',
        carTell:'',
        mail:'',
        name:'',
        tell:'',
        remark:'',
        img:[],
      },
      rules:{
        ship:[
          { required: true, message: '请选择船舶', trigger: 'change' },
        ],
        reason:[
          { required: true, message: '请选择停靠原因', trigger: 'change' },
        ],
        port:[
          { required: true, message: '请选择停靠港口', trigger: 'change' },
        ],
        start:[
          { required: true, message: '选择停靠开始时间', trigger: 'change' },
        ],
        end:[
          { required: true, message: '请选择停靠结束时间', trigger: 'change' },
        ],
      },
      baseImgUrl: baseImgUrl+ '/',
      uploadUrl:'',
      uploadData: {
        fileType: '1',
      },
      imgIsUpload:false,
    };
  },
  mounted() {
    this.init();
    this.uploadUrl = baseUrl + '/web/attachment/upload'
  },
  methods: {
    async init(){
      // await this._stopShipCvPageList();
      const res = await getParam({categoryCd:'special_reason'})
      if(res.status !== 0) this.$message.error(res.message);
      else {
        this.stateOption = [{attrNm: '全部', id: ''}, ...res.data.map(item => {
          return {
            attrNm: item.classaName,
            id: item.id,
          }
        })]
        this.reasonOption=res.data.map(item => {
          return {
            attrNm: item.classaName,
            id: item.id,
          }
        })
      }
      const res2 = await getShips()
      if(res2.status !== 0) this.$message.error(res2.message);
      else this.shipOption=res2.data;
      // const res3 = await getPorts()
      // if(res3.status !== 0) this.$message.error(res3.message);
      // else this.portOption=res3.data.map(item=>{
      //   return{
      //     name:item.name,
      //     id:item.id,
      //     address: item.address,
      //   }
      // });
    },
    async _stopShipCvPageList(){
      this.tableLoad=true;
      const res = await stopShipCvPageList(
        {
          shipName:this.shipIpt,
          voyageNumber:this.voyageIpt,
          taskNumber:this.numberIpt,
          stopReasonId:this.reasonIpt,
          status:this.reasonIpt,
          startTime:this.startTime,
          endTime:this.endTime,
          // startTime:this.timeIpt[0]?this.timeIpt[0]:'',
          // endTime:this.timeIpt[1]?this.timeIpt[1]:'',
          rows:this.size,
          page:this.page,
        }
      )
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total
    },
    // 结束时间
    dateChange(val) {
      if(this.endTime&&this.startTime&&(this.endTime <= this.startTime)) {
        if(val == this.endTime) this.endTime = '';
        if(val == this.startTime) this.startTime = '';
        return this.$message.warning("结束日期必须大于开始日期！");
      }
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._stopShipCvPageList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._stopShipCvPageList();
    },
    async detailClick(id){
      this.detailDialogVisible=true;
      const res = await stopShipCvDetail(id)
      if(res.status !== 0) return this.$message.error(res.message);
      this.detailData={
        ...res.data,
        img:res.data.imgUrl.split(","),
      };
      this.operationData=res.data.operateRecordList;
    },
    bjDate(date, date1) {
      var date = new Date(date);
      var date1 = new Date(date1);
      // 减小于0 date<date1
      return date.getTime() - date1.getTime() < 0;
    },
    beforeAvatarUpload(file) {
      const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg']
      const isJPG =TypeArr.includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式')
      if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB')
      return isJPG && isLt10M
    },
    uploadChange(file, fileList){
      this.teamData.img=fileList;
      if (Object.keys(file).includes('response')){
        if (file.response.status !==0){
          this.teamData.img.splice(this.teamData.img.indexOf(file),1)
        }
      }
    },
    handleRemove(file,fileList) {
      this.teamData.img=fileList;
    },
    success(res){
      if(res.status!==0) this.$message.error('该图片上传失败！')
      this.$message.success(res.message)
      this.imgIsUpload=false;
    },
    progress(){
      this.imgIsUpload=true;
    },
    changeClick(item){
      const imgArr = item.imgUrl.split(',');
      const img = [];
      imgArr.forEach(item=>img.push({url:baseImgUrl+'/'+item}))
      this.teamData={
        ...item,
        ship:{id:item.shipId,name:item.shipName},
        voyage:item.voyageNumber,
        number:item.taskNumber,
        port2:item.leavePortName,
        port:{name:item.stopPortName,id:item.stopPortId,address:item.stopPortAddress},
        reason: {id:item.stopReasonId,attrNm:item.stopStartTime},
        start:item.stopStartTime,
        end:item.stopEndTime,
        mark:item.remark,
        img,
      };
      this.dialogTitle='修改特殊停船';
      this.dialogVisible=true;
    },
    searchBtn(){
      this.page = 1;
      this._stopShipCvPageList();
    },
    resetBtn(){
      this.shipIpt='';
      this.voyageIpt='';
      this.numberIpt='';
      // this.timeIpt='';
      this.startTime = '';
      this.endTime = '';
      this.reasonIpt='';
    },
    addBtn(){
      this.dialogTitle='添加特殊停船';
      this.dialogVisible=true;
    },
    tableRowClassName({row}) {
      if (row.state==='审核未通过') return 'ui-warning-row';
      else return '';
    },
    addClick(){
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          if(!this.bjDate(this.teamData.start ,this.teamData.end)) return this.$message.warning('结束时间不得小于开始时间！');
          let str ='';
          this.teamData.img.forEach(item=>{
            if(!item.response) str+=item.url.split(baseImgUrl+'/')[1]+','
            else str += item.response.data.attachmentGroup + '/' + item.response.data.attachmentPath + ','
          })
          str = str.slice(0,str.length-1);
          const obj = {
            id:this.teamData.id,
            shipId:this.teamData.ship.id,
            shipName:this.teamData.ship.name,
            voyageNumber:this.teamData.voyage,
            taskNumber:this.teamData.number,
            leavePortId:this.teamData.leavePortId,
            arrivalPortId:this.teamData.arrivalPortId,
            leavePortName:this.teamData.port2,
            arrivalPortName:this.teamData.arrivalPortName,
            stopReasonId:this.teamData.reason.id,
            stopReason:this.teamData.reason.attrNm,
            stopPortId:this.teamData.port.id,
            stopPortName:this.teamData.port.name,
            stopPortAddress:this.teamData.port.address,
            stopStartTime:this.teamData.start,
            stopEndTime:this.teamData.end,
            remark:this.teamData.mark,
            imgUrl:str,
          };
          this.imgIsUpload = true;
          const res = this.dialogTitle==='添加特殊停船'?await stopShipCvAdd(obj):await stopShipCvUpdate(obj);
          this.imgIsUpload = false;
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.dialogVisible=false;
          await this._stopShipCvPageList();
        } else return false;
      });
    },
    async shipChange(){
      const res = await getStopByDeployId(this.teamData.ship.id)
      if(res.status !== 0) return this.$message.error(res.message);
      this.teamData={
        ...this.teamData,
        ...res.data,
        voyage:res.data.voyageNumber,
        number:res.data.taskNumber,
        port2:res.data.leavePortName,
        leavePortId:res.data.leavePortId,
      }
    },
    dialogClose(){
      this.dialogVisible=false;
      this.teamData={
        teamName:'',
        keyword:'',
        account:'',
        area:'',
        address:'',
        carTell:'',
        mail:'',
        name:'',
        tell:'',
        remark:'',
        img:[],
      };
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .img-box{
    position: relative;
    width: 150px;
    height: 100px;
    img{
      width: 150px;
      height: 100px;
    }
    .tips{
      position: absolute;
      display:none;
    }
    &:hover .tips{
      display:block;
      position:absolute;
      //bottom:0;
      top:0;
      left:0;
      color:#FFF;
      width:146px;
      z-index:10;
      height:148px;
      background:#000;
      opacity: 0.6;
    }
  }
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .navContainer p {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .imgContainer{
            display:flex;
            align-items: center;
          }
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px 10px 10px;
    max-height:80vh;
    overflow:auto;
    &Ship{
      display: flex;
      flex-direction: column;
      height:50px;
      justify-content:space-around;
      width: calc(100% - 130px);
      margin-left: 130px;
      span{
        font-size: 14px;
        color: #606266;
        font-weight: 700;
      }
    }
    .imgUp{
      display: flex;
      flex-direction: column;
      .imgLength{
        display: flex;
        align-items: center;
        width:90%;
        span{
          margin-left:auto;
          color: rgb(183, 183, 183);
          font-size: 16px;
        }
      }
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item{
        margin-bottom:15px;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 90%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0 5px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-table .ui-warning-row {
    background: #DDD!important;
  }
  .el-table .ui-warning-row .cell{
    color: red;
  }
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
